
import { IDataSource } from "./IDataSource";


export class DataSource implements IDataSource
{
    id: number = 0;
    companyId: number = 0;
    code: string = "";
    name: string = "";
    description: string = "";
    unitOfMeasureId: number = 0;
    unitOfMeasureCode: string = "";
    unitOfMeasureName: string = "";
    active: boolean  = false;
    dataTag: string = "";
    dataSourceCollectorTypeId: number = 0;
    dataSourceCollectorTypeName: string = "";
}
